import React from 'react';
import useModal from './useModal';
import useOrganizationSearch from './useOrganizationSearch';
import CohortItem from './CohortItem';
import { useQuery } from '@tanstack/react-query';
import { authHeaders } from 'actions';
import axios from 'axios';
import Routes from 'utils/routes.js.erb';
import PropTypes from 'prop-types';

const CohortList = ({group, subgroup}) => {
  const { openModal } = useModal();
  const { results } = useOrganizationSearch();
  const { data } = useQuery({
    queryKey: [
      'administration', 'organization', 'groups', group.id, 'subgroups', subgroup.id, 'cohorts',
    ],
    queryFn: ({ signal }) => axios.get(
      Routes.api_dashboard_administration_organizations_cohorts_path({group_id: group.id, subgroup_id: subgroup.id}),
      { headers: authHeaders(), signal }
    ).then(response => response.data),
  })

  return (
    <ul>
      {(results ? (data || []).filter(c => results.visibleCohortIds.has(c.id)) : (data || [])).map(cohort => <li key={cohort.id}><CohortItem group={group} subgroup={subgroup} cohort={cohort} /></li>)}
      {subgroup.can_add_child && (
        <li className='add level3'>
          <a className='add-button' onClick={() => openModal('cohort', group, subgroup)}>
            <i className="fa fa-plus-circle"></i>
            Add Cohort
          </a>
        </li>
      )}
    </ul>
  );
}

CohortList.propTypes = {
  group: PropTypes.object.isRequired,
  subgroup: PropTypes.object.isRequired,
}

export default CohortList;
